<template>
  <div class="ex-checkpoint-band">
    <v-chip :class="classes">
        <span :class="textClasses" class="prop-status-label">{{ level }} Level</span>
    </v-chip>
  </div>
</template>

<script setup>
import { computed } from 'vue';
// Props definition
const props = defineProps({
  level: {
    type: String,
    validator: function (value) {
      return ['Apprentice', 'Professional', 'Coach', 'Master'].indexOf(value) !== -1;
    },
  }
});

const classes = computed(() => {
  const levelClass = `checkpoint-band--${props.level}`;
  return {
    [levelClass]: true,
  };
});

const textClasses = computed(() => {
  return {
    [`checkpoint-text--${props.level}`]: true,
  };
});
</script>

<style>
.ex-checkpoint-band {
  display: flex;
  align-items: center;
}

/* Center content inside Vuetify chip */
.ex-checkpoint-band .v-chip__content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ex-checkpoint-band .checkpoint-band--Apprentice {
  border-radius: 0px !important;
  border: 1px solid;
  border-color:#E58700 !important;
  background-color: #FFF5D3 !important;
  width: 100%;
  height: 35px;
}

.ex-checkpoint-band .checkpoint-band--Professional {
  border-radius: 0px !important;
  border: 1px solid;
  border-color: #00B813 !important;
  background-color: #F3FFF9 !important;
  width: 100%;
  height: 35px;
}

.ex-checkpoint-band .checkpoint-band--Coach {
  border-radius: 0px !important;
  border: 1px solid;
  border-color: #00A3FF !important;
  background-color: #EFFEFF !important;
  width: 100%;
  height: 35px;
}

.ex-checkpoint-band .checkpoint-band--Master {
  border-radius: 0px !important;
  border: 1px solid;
  border-color: #2E1EC1 !important;
  background-color: #F2F3FF !important;
  width: 100%;
  height: 35px;
}

.ex-checkpoint-band .checkpoint-text--Apprentice {
  color: #E58700 !important;
}

.ex-checkpoint-band .checkpoint-text--Professional {
  color: #00B813 !important;
}

.ex-checkpoint-band .checkpoint-text--Coach {
  color: #00A3FF !important;
}

.ex-checkpoint-band .checkpoint-text--Master {
  color: #2E1EC1 !important;
}

.ex-checkpoint-band .prop-status-label {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
}

.checkpoint-band--Apprentice:hover:before {
  opacity: 0 !important;
}

.checkpoint-band--Professional:hover:before {
  opacity: 0 !important;
}

.checkpoint-band--Coach:hover:before {
  opacity: 0 !important;
}

.checkpoint-band--Master:hover:before {
  opacity: 0 !important;
}
</style>

  